import { NetworkEventType } from '../wsServices/WsNetworkService';
import { IWsSpecificNetworkService } from './WsSpecificNetworkService.types';

export class WsSubscribeManager {
  private subscribers: Array<() => void> = [];

  constructor(private wsNetworkService: IWsSpecificNetworkService) {
    this.wsNetworkService.on(NetworkEventType.Open, () => this.resend());
  }

  public subscribe(callback: () => void): () => void {
    this.subscribers.push(callback);

    if (this.wsNetworkService.isWsOpen) {
      callback();
      return () => this.unsubscribe(callback);
    }

    return () => this.unsubscribe(callback);
  }

  public unsubscribe(callback: () => void): void {
    this.subscribers = this.subscribers.filter(
      (subscribeCallback) => subscribeCallback !== callback
    );
  }

  public resend(): void {
    this.subscribers.forEach((callback) => callback());
  }
}
